import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgQuestion = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.75 9.745a1.25 1.25 0 1 1 1.708 1.163c-.518.204-1.208.732-1.208 1.592a.75.75 0 0 0 1.5.002.2.2 0 0 1 .034-.05.6.6 0 0 1 .224-.148 2.75 2.75 0 1 0-3.758-2.56.75.75 0 0 0 1.5 0"
        clipRule="evenodd"
      />
      <path fill="currentColor" d="M12 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M8.747 4.147a8.5 8.5 0 1 1 6.506 15.706A8.5 8.5 0 0 1 8.747 4.147"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgQuestion;
